import { Link, useParams } from "react-router-dom";

export default function UserTab(props) {
    const params = useParams();
    return (
        <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item">
                <Link to={"/userdashboard/application/" + params.lendingApplicationId} className={props.pagename === "application" ? "nav-link active" : "nav-link"}>
                    <i className="ri-list-unordered d-inline-block d-md-none" /> <span>Application</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link to={"/userdashboard/documents/"+ params.lendingApplicationId} className={props.pagename === "documents" ? "nav-link active" : "nav-link"}>
                    <i className="ri-folder-4-line d-inline-block d-md-none" /> <span className="d-none d-md-inline-block">Documents</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link to={"/userdashboard/lenders/"+ params.lendingApplicationId} className={props.pagename === "lenders" ? "nav-link active" : "nav-link"}>
                    <i className="ri-airplay-fill d-inline-block d-md-none" /> <span className="d-none d-md-inline-block">Matching Funders</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link to={"/userdashboard/offers/"+ params.lendingApplicationId} className={props.pagename === "offers" ? "nav-link active" : "nav-link"}>
                    <i className="ri-airplay-fill d-inline-block d-md-none" /> <span className="d-none d-md-inline-block">Offers</span>
                </Link>
            </li>
        </ul>
    );
}